import React from 'react';
import { i18n } from '@international/mastodon-i18n';
import { getUploadCustomText } from 'components/fields/helper';
import { MAX_FILE_SIZE, ALLOWED_MIME_TYPES } from '../../../constants';
import deleteFileStackLink, {
  deleteFileStackLinkGuarded,
} from '../lib/deleteFileStackLink';
import useMissingUrlGuard from './useMissingUrlGuard';

type RequiredItem<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

const deleteVerificationUpload = (file: object) =>
  deleteFileStackLinkGuarded(file, 'verification-documents');

const FileStackDefaultOptions: RequiredItem<any, 'maxFiles'> = {
  accept: ALLOWED_MIME_TYPES,
  storeTo: { location: 'S3' },
  fromSources: ['local_file_system'],
  maxFiles: 1,
  disableTransformer: true,
  uploadInBackground: false,
  onFileUploadFinished: deleteFileStackLink,
  customText: getUploadCustomText(),
  lang: i18n.getLocale().substring(0, 2),
  maxSize: MAX_FILE_SIZE,
};

const useFilestackOptions = (options: any): RequiredItem<any, 'maxFiles'> => {
  // ECDEX-3961: cdx_cp_filestack_missing_url_guard picks the delete; off,
  // FileStackDefaultOptions is used unchanged.
  const missingUrlGuard = useMissingUrlGuard();
  const onFileUploadFinished = missingUrlGuard
    ? deleteVerificationUpload
    : deleteFileStackLink;
  const [resultOptions, setResultOptions] = React.useState<
    RequiredItem<any, 'maxFiles'>
  >({
    ...FileStackDefaultOptions,
    onFileUploadFinished,
    ...options,
  });
  React.useEffect(() => {
    setResultOptions({
      ...FileStackDefaultOptions,
      onFileUploadFinished,
      ...options,
    });
  }, [options, onFileUploadFinished]);
  return resultOptions;
};
export default useFilestackOptions;
